import { CriteriUtente } from '../../../models/criteri-utente';
import { CriterioCustom } from '../../../models/criterio-custom';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { SearchCriteria } from '../../../models/search-criteria';

export class RequestSearchRiunisci {
  searchCriteria: SearchCriteria;
  includePratiche: boolean = true;
  fromResult = 0;

  constructor(fascicolo: FascicoloFull) {
    this.searchCriteria = new SearchCriteria();
    this.searchCriteria.criteriUtente = new CriteriUtente();
    this.searchCriteria.criteriUtente.criteriCustom['tipoFascicolo'] = new CriterioCustom();
    this.searchCriteria.criteriUtente.criteriCustom['tipoFascicolo'].uid = "tipoFascicolo";
    this.searchCriteria.criteriUtente.criteriCustom['tipoFascicolo'].value = null;
    this.searchCriteria.criteriUtente.criteriCustom['giudice'] = new CriterioCustom();
    this.searchCriteria.criteriUtente.criteriCustom['giudice'].uid = "giudice";
    this.searchCriteria.criteriUtente.criteriCustom['giudice'].value = null;
    this.searchCriteria.criteriUtente.criteriCustom['dataUdienza'] = new CriterioCustom();
    this.searchCriteria.criteriUtente.criteriCustom['dataUdienza'].uid = "dataUdienza";
    this.searchCriteria.criteriUtente.criteriCustom['dataUdienza'].value = null;
    this.searchCriteria.criteriUtente.criteriCustom['dataUdienza'].dataType = "date";
    this.searchCriteria.criteriUtente.criteriCustom['nomeControparte'] = new CriterioCustom();
    this.searchCriteria.criteriUtente.criteriCustom['nomeControparte'].uid = "nomeControparte";
    this.searchCriteria.criteriUtente.criteriCustom['nomeControparte'].value = null;
    this.searchCriteria.criteriUtente.criteriCustom['cognomeControparte'] = new CriterioCustom();
    this.searchCriteria.criteriUtente.criteriCustom['cognomeControparte'].uid = "cognomeControparte";
    this.searchCriteria.criteriUtente.criteriCustom['cognomeControparte'].value = null;
    this.searchCriteria.criteriUtente.criteriCustom['numeroRuolo'] = new CriterioCustom();
    this.searchCriteria.criteriUtente.criteriCustom['numeroRuolo'].uid = "numeroRuolo";
    this.searchCriteria.criteriUtente.criteriCustom['numeroRuolo'].value = null;
    if (fascicolo.autoritaGiudiziaria) {
      this.searchCriteria.criteriUtente.criteriCustom['autoritaGiudiziaria'] = new CriterioCustom();
      this.searchCriteria.criteriUtente.criteriCustom['autoritaGiudiziaria'].uid = "autoritaGiudiziaria";
      this.searchCriteria.criteriUtente.criteriCustom['autoritaGiudiziaria'].value = fascicolo.autoritaGiudiziaria.id;
    }
    if (fascicolo.autoritaGiudiziariaCitta) {
      this.searchCriteria.criteriUtente.criteriCustom['sedeAutorita'] = new CriterioCustom();
      this.searchCriteria.criteriUtente.criteriCustom['sedeAutorita'].uid = "sedeAutorita";
      this.searchCriteria.criteriUtente.criteriCustom['sedeAutorita'].value = fascicolo.autoritaGiudiziariaCitta.id;
    }
    this.searchCriteria.criteriUtente.criteriCustom['materia'] = new CriterioCustom();
    this.searchCriteria.criteriUtente.criteriCustom['materia'].uid = "materia";
    this.searchCriteria.criteriUtente.criteriCustom['materia'].value = null;
    this.searchCriteria.criteriUtente.criteriCustom['oggetto'] = new CriterioCustom();
    this.searchCriteria.criteriUtente.criteriCustom['oggetto'].uid = "oggetto";
    this.searchCriteria.criteriUtente.criteriCustom['oggetto'].value = null;
    this.searchCriteria.tipoPratica = null;
    this.searchCriteria.inizioFascicoloDataDa = null;
    this.searchCriteria.inizioFascicoloDataA = null;
    this.searchCriteria.posizionePratica = null;
  }
}
